import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { listByParamCodes } from '@/api/common'
import Cascader from '../index.vue'
import { paramCodesDataFilter } from '@/utils/index'
import { useInteractionStore } from '@/stores/interaction'
import type { ParamCodeItem } from '@/typings/common'

const __default__ = { name: 'ParamCodeCascader' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    appId: {},
    paramCode: {},
    options: {},
    status: {}
  },
  setup(__props: any) {

const shareInfo = useInteractionStore()
const props = __props
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
const treeOptions = ref<ParamCodeItem[]>([])
const fetch = () => {
  if (props.appId && props.paramCode) {
    listByParamCodes({
      appId: props.appId,
      paramCodes: [props.paramCode]
    }).then((res) => {
      if (props.status != null) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, props.status)
      }
      treeOptions.value = props.paramCode && res.data?.[props.paramCode]
    })
  }
}

watch(
  () => props.options,
  () => {
    if (typeof props.options !== 'undefined') {
      treeOptions.value =
        props.status != null ? paramCodesDataFilter({ paramKey: props.options }, props.status)?.paramKey : props.options
    } else {
      fetch()
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Cascader, _mergeProps(_ctx.$attrs, {
    appId: _ctx.appId,
    paramCode: _ctx.paramCode,
    options: treeOptions.value,
    fieldNames: { label: eumns[_unref(shareInfo).language], value: 'id' },
    placeholder: _ctx.$t('common.pleaseSelect'),
    "change-on-select": "",
    allowClear: ""
  }), null, 16, ["appId", "paramCode", "options", "fieldNames", "placeholder"]))
}
}

})